// @tennis-matches/services/governance
/**
 * Kanonische **globaler Superadmin**-Erkennung (UI + Guards).
 *
 * Reihenfolge (identisch zu `app_config.is_global_superadmin()` / `public.is_superadmin()`):
 * 1. Binding `role = superadmin` mit `scope = global` oder `scope_id = global`
 * 2. JWT `user.app_metadata.role === 'superadmin'` (nur Auth-Admin setzbar)
 *
 * Bewusst **kein** `user_metadata.role` — Clients können `user_metadata` via
 * `auth.updateUser` selbst setzen (Privilege Escalation).
 *
 * @param {unknown[]} roleBindings
 * @param {object|null|undefined} authUser
 * @returns {boolean}
 */
export function isGlobalSuperadminForSession(roleBindings, authUser) {
  const list = Array.isArray(roleBindings) ? roleBindings : [];
  const fromBindings = list.some((b) => {
    const role = String(b?.role ?? "")
      .trim()
      .toLowerCase();
    const scope = String(b?.scope ?? "")
      .trim()
      .toLowerCase();
    const scopeId = String(b?.scope_id ?? "")
      .trim()
      .toLowerCase();
    return (
      role === "superadmin" && (scope === "global" || scopeId === "global")
    );
  });
  if (fromBindings) return true;
  if (!authUser || typeof authUser !== "object") return false;
  const appMeta = authUser.app_metadata;
  const appRole = String(
    appMeta && typeof appMeta === "object" ? (appMeta.role ?? "") : "",
  )
    .trim()
    .toLowerCase();
  return appRole === "superadmin";
}

/** Pfade, die ausschließlich dem globalen Superadmin vorbehalten sind. */
const __GLOBAL_SUPERADMIN_ROUTE_EXACT = new Set([
  "superadmin",
  "content-admin",
  "i18n-admin",
  "form-admin",
  "superadmin-exercise-metadata",
  "superadmin-repository-coverage",
  "superadmin-feature-flags",
  "superadmin-reports",
  "superadmin-bpmn",
  "superadmin-i18n-upload",
  "superadmin-governance",
  "superadmin-clubs",
  "superadmin-password-reset",
  "superadmin-appearance",
  "superadmin-config",
  "superadmin-metrics",
]);

/**
 * @param {string} route – erstes URL-Segment (ohne führenden Slash)
 * @returns {boolean}
 */
export function isGlobalSuperadminOnlyRoute(route) {
  const r = String(route ?? "")
    .trim()
    .toLowerCase()
    .replace(/\/$/, "");
  if (!r) return false;
  if (__GLOBAL_SUPERADMIN_ROUTE_EXACT.has(r)) return true;
  return r.startsWith("superadmin-");
}
